import React from "react";
import { FormBuilder } from "../form/FormBuilder";
import { BillingCode, BillingCodeType } from "../../interfaces/screens/billing";
import { FormComponent } from "../../shared/utils/enums";

interface BillingCodeEditorProps {
  code?: BillingCode;
  onClose: () => void;
  onSave: (code: BillingCode) => void;
}

const BillingCodeEditor: React.FC<BillingCodeEditorProps> = ({
  code,
  onClose,
  onSave,
}) => {
  const handleFormSubmit = (formData: any) => {
    const finalCode = {
      ...code,
      ...formData,
    };
    onSave(finalCode);
    onClose();
  };

  const codeFormSchema: any = {
    type: "object",
    properties: {
      code: {
        label: "Code",
        component: FormComponent.Input,
        type: "string",
        required: true,
      },
      type: {
        label: "Type",
        component: FormComponent.Select,
        type: "string",
        required: true,
        options: [
          { value: "cpt", label: "CPT" },
          { value: "icd", label: "ICD" },
          { value: "ndc", label: "NDC" },
          { value: "service", label: "Service" },
        ],
      },
      unit_price: {
        label: "Unit Price (Optional)",
        component: FormComponent.Input,
        type: "number",
        required: false,
        componentProps: {
            type: 'number'
        }
      },
      currency: {
        label: "Currency",
        component: FormComponent.Select,
        type: "string",
        required: false,
        defaultValue: "USD",
        options: [
          { value: "USD", label: "USD" },
          { value: "LBP", label: "LBP" },
          { value: "EUR", label: "EUR" },
        ],
        componentProps: {},
      },
      nssf_coverage_percentage: {
        label: "NSSF Coverage Percentage",
        component: FormComponent.Input,
        type: "number",
        required: false,
        defaultValue: 80,
        componentProps: {
          type: "number",
          min: 0,
          max: 100,
          step: 1,
        },
      },
      moph_coverage_percentage: {
        label: "MOPH Coverage Percentage",
        component: FormComponent.Input,
        type: "number",
        required: false,
        defaultValue: 100,
        componentProps: {
          type: "number",
          min: 0,
          max: 100,
          step: 1,
        },
      },
      description: {
        label: "Description",
        component: FormComponent.Textarea,
        type: "string",
        required: true,
      },
      notes: {
        label: "Notes",
        component: FormComponent.Textarea,
        type: "string",
        required: false,
        componentProps: {
        },
      },
      requires_preauthorization: {
        label: "Requires Pre-authorization",
        component: FormComponent.Checkbox,
        type: "boolean",
        required: false,
        defaultValue: false,
        componentProps: {},
      },
      is_covered_by_nssf: {
        label: "Covered by NSSF",
        component: FormComponent.Checkbox,
        type: "boolean",
        required: false,
        defaultValue: true,
        componentProps: {},
      },
      is_covered_by_moph: {
        label: "Covered by MOPH",
        component: FormComponent.Checkbox,
        type: "boolean",
        required: false,
        defaultValue: true,
        componentProps: {},
      },
    },
  };

  return (
    <div className="p-6">
      <FormBuilder
        schema={codeFormSchema}
        onSubmit={handleFormSubmit}
        initialValues={code}
        buttonType="cancel-save"
      />
    </div>
  );
};

export default BillingCodeEditor; 